import React, { useEffect, useState } from "react";
import { useFetch } from "../Hooks/Conexao";
import * as api from "./api";
import { Select } from "antd";
import { InputPadrao } from "../Base";

function SelectEstadosCidades({ setCidade, cidade, estado, setEstado, ...props }) {
  const [cidades, listarCidade, loadingCidade, setCidades] = useFetch();
  const [estados, listarEstado, loadingEstado] = useFetch(() => api.GetEstado());

  useEffect(() => {
    listarEstado();
  }, []);

  useEffect(() => {
    if (props.mode !== "multiple" && !!estados) {
      setCidade(null);
    }

    listarCidade(() => api.GetCidade(((estados || []).find(x => x.nome == estado) || []).id),
      cidades => {
        let aux = cidades.sort((a, b) => a.municipio.nome > b.municipio.nome ? 1 : -1).map(x => x.municipio.nome)
        aux = [...new Set(aux)];
        setCidades(aux);
      });
  }, [estado]);

  return (
    <>
      <p style={{ fontWeight: "bold", margin: 0, marginTop: 15, display: "block", }}>Estado</p>

      <Select allowClear loading={loadingEstado} value={estado} style={{ width: "100%" }} onChange={v => setEstado(v)} showSearch>
        {(estados || []).sort((a, b) => {
          if (a.nome > b.nome) return 1;
          else return -1
        }).map(x => (
          <Select.Option key={x.nome}>{x.nome}</Select.Option>
        ))}
      </Select>
      <p style={{ fontWeight: "bold", margin: 0, marginTop: 15, display: "block", }}>Cidade</p>
      <Select
        allowClear
        {...props}
        loading={loadingCidade}
        value={cidade}
        style={{ width: "100%" }}
        disabled={!estado}
        onChange={v => setCidade(v)}
        showSearch
      >
        {(cidades || []).map(x => (<Select.Option key={x}>{x}</Select.Option>))}
      </Select>
      {/* <InputPadrao value={cidade} onChange={(v) => setCidade(v.target.value)} /> */}
      {/* <pre>{JSON.stringify(cidades, null, 2)}</pre> */}
    </>
  );
}

export default SelectEstadosCidades;
